import { CommonModule } from "@angular/common";
import {
	AfterViewInit,
	Component,
	ElementRef,
	forwardRef,
	Input,
	NgModule,
	OnChanges,
	OnInit,
	SimpleChanges,
	ViewChild,
} from "@angular/core";
import { FormsModule, NG_VALUE_ACCESSOR } from "@angular/forms";

import { TranslateModule } from "@codeandweb/ngx-translate";

import { ControlValueAccessorBase } from "@app/_helpers/control-value-accessor-base";
import { ParametreService } from "@app/parametre/parametre.service";
import { AngularEditorConfig, AngularEditorModule } from "../html-editor-lib/public-api";

@Component({
	selector: 'html-editor',
	templateUrl: './html-editor.html',
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => HTMLEditorComponent),
			multi: true
		}
	],
})
export class HTMLEditorComponent extends ControlValueAccessorBase<string | null> implements AfterViewInit, OnChanges {

	@ViewChild('editor') editor: {textArea: ElementRef<HTMLElement>};

	@Input('value') innerValue: string | null;
	@Input() required: boolean = false;
	@Input() disabled: boolean = false;
	@Input() readonly: boolean = false;
	@Input() placeholder: string = '';

	editorConfig: AngularEditorConfig = {
		editable: false,
		spellcheck: false,
		enableToolbar: false,
		minHeight: '50px',
		outline: false
	};

	constructor(private parametreService: ParametreService){
		super();
	}

	ngAfterViewInit(): void {
		this.editor.textArea.nativeElement.contentEditable = this.readonly ? 'false' : 'true';
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (!changes.readonly.isFirstChange()) {
			let editable = !changes.readonly.currentValue;
			this.editorConfig = {
				...this.editorConfig,
				editable: editable,
				// ne fonctionne pas ?
				//enableToolbar: editable,
				//showToolbar: editable
			};
			this.editor.textArea.nativeElement.contentEditable = editable ? 'true' : 'false';
		}
	}

}

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		TranslateModule,
		AngularEditorModule,
	],
	exports: [HTMLEditorComponent],
	declarations: [HTMLEditorComponent]
})
export class HTMLEditorModule {}
